import {
    FETCH_REFUNDVERIFYS
} from '../actions/refundVerify';


export const initialState = {
    isFetching: true,
    data: null
};

export const refundVerifys = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REFUNDVERIFYS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REFUNDVERIFYS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/refundVerify.js